import { HttpContextToken } from '@angular/common/http';

export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const EXTERNAL_REQUEST = new HttpContextToken<boolean>(() => false);
